import baseConfig from "./baseconfig.json";

const host = window.location.protocol + "//" + window.location.host;

const domainMapping = baseConfig.domainMapping;

const currentFlavor =
  Object.keys(domainMapping).find((key) =>
    domainMapping[key].some((domain) => host.includes(domain))
  ) || "default";

// const currentFlavor = "nodeui";

const selectedConfig = baseConfig.flavors[currentFlavor] || {};
console.log(currentFlavor);
console.log(selectedConfig, "selectedConfig");

const conf = {
  ...baseConfig.common,
  ...selectedConfig,
  fleetURL: selectedConfig.url + "/public/fleet",
  baseURL: selectedConfig.url,
  fleetURLAdvertise: selectedConfig.url + "/public/fleet/",
  // NodeCoreUrl: "https://dolphin.trackeazy.com",
  NodeCoreUrl: selectedConfig.url,

  reportUrl: "http://172.31.43.85:5000/",
  reportUrl2: "https://dolphin.trackeazy.com",
  reportUrl3: "https://www.awtltrack.com/",
  // NodeCoreUrl: "http://localhost:3056",
  excelUrl: "http://localhost:3076",
  pythonReportlUrl: "https://portal.awtltrack.com",
  currentFlavor: currentFlavor,
  pythonReport: 1,
};

export default conf;
